/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Type_TitleInputs */



/**
* | output |
* | --- |
* | "Title" |
*
* @param {Knp_Terms_Type_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_type_title = /** @type {((inputs?: Knp_Terms_Type_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Type_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Titel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Titolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заголовок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Título")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイトル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Título")
	return /** @type {LocalizedString} */ ("Title")
});